import ApplicationController from '../../../javascript/controllers/application_controller'

export default class extends ApplicationController {
  static values = {
    autoHide: Boolean,
    timeout: Number
  }

  connect() {
    this.#animateEntrance()
    if (this.hasAutoHideValue ? this.autoHideValue : true) {
      setTimeout(
        () => this.close(),
        this.hasTimeoutValue ? this.timeoutValue : 15000
      )
    }
  }

  close() {
    this.#animateExit()
    setTimeout(() => this.hide(), 300)
  }

  hide() {
    this.element.classList.add('hidden')
  }

  #animateEntrance() {
    this.element.classList.add('toastUp')
  }

  #animateExit() {
    this.element.classList.add('fadeOutToast')
  }
}
